export class Usuario {
    constructor() {
        this.email = '';
        this.senha = '';
    }

    email: string;
    senha: string;
}